import loadingVideo from '../assets/animations/loading.mp4';

interface LoadingOverlayProps {
    visible: boolean;
    aspectRatio?: number | null;
    forceFill?: boolean;
}

export default function LoadingOverlay({ visible, aspectRatio, forceFill = false }: LoadingOverlayProps) {
    if (!visible) return null;

    return (
        <div className={`loading-page${forceFill ? ' loading-page--fill' : ''}`} style={{
            width: '100%',
            height: forceFill ? '100%' : (aspectRatio ? 'auto' : '100%'),
            aspectRatio: forceFill ? undefined : (aspectRatio ? `${aspectRatio}` : undefined),
            userSelect: 'none',
        }}>
            <video
                src={loadingVideo}
                autoPlay
                loop
                muted
                playsInline
                style={{ width: 200, height: 200 }}
            />
        </div>
    );
}
